<template>
  <v-flex>
    <v-dialog v-model="dialogBusquedaClientes" width="500" persistent>
      <v-card class="mx-auto elevation-0" outlined :color="'rgb(250, 250, 250)'" :style="'border: 1px solid grey;'">
        <v-toolbar dense :color="colorBarraFormulario" dark flat>
          <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
            <h5 v-bind:style="{ color: 'white' }">
              RESULTADO DE BUSQUEDA DE CLIENTES
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon size="30" :color="'white'" @click="dialogBusquedaClientes = false">mdi-close-circle</v-icon>
        </v-toolbar>

        <v-card-text class="mt-0">
          <v-list color="transparent" nav dense>
            <v-list-item-group :color="colorBarraFormulario">
              <template v-for="client in clientes">
                <v-list-item :key="client.id" v-if="client" @click="_selecCliente(client)">
                  <v-list-item-avatar color="success">
                    <v-avatar size="40px">
                      <v-icon class="ml-0" size="38px">mdi-account-circle</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ client.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>{{ client.telefono }}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{ client.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card min-height="800" :color="'rgb(250, 250, 250)'" class="elevation-0">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
          <h5 v-bind:style="{ color: 'white' }">PRESUPUESTO</h5>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip v-if="modelReserva.url_presupuesto" class="mr-2 px-10" label :color="'green lighten-2'" text-color="white"
          link :href="modelReserva.url_presupuesto" target="_blank">
          <span v-bind:style="{ color: 'white' }">Ver Presupuesto</span>
        </v-chip>
        <v-chip class="mr-4 px-10" label :color="colorAccent1" text-color="white" link @click="_guardarReserva">
          <span v-if="loading" v-bind:style="{ color: 'white' }">Guardando...</span>
          <span v-else v-bind:style="{ color: 'white' }">Guardar</span>
        </v-chip>
        <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
      </v-toolbar>

      <v-row class="mx-4">
        <v-col cols="9">

          <v-container class="px-4 pt-4 pb-4">
            <v-row>
              <v-col>
                <v-tabs background-color="rgb(220, 220, 220)" grow v-model="tab">
                  <v-tab v-for="(header, index) in tabHeaders" :key="index">
                    {{ header }}
                  </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mt-0 mx-4 mb-2 text-center">
                          <v-spacer></v-spacer>
                          <span v-bind:style="{ color: 'grey' }">Datos de la Reserva
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>
                        <v-row dense class="mx-4">
                          <v-select class="mt-0 mr-0" :items="caminos" label="Seleccione el camino" dense :dark="dark"
                            outlined v-model="modelReserva.camino" item-text="titulo" return-object
                            @change="_changeCamino()">
                          </v-select>
                        </v-row>

                        <v-row dense class="mt-2 mx-4">
                          <v-select class="mt-0 mr-0" label="Seleccione el origen" dense :dark="dark" outlined
                            v-model="modelReserva.origen" :items="origenes" item-text="nombre" item-value="id"
                            return-object>
                          </v-select>
                        </v-row>

                        <v-row dense class="mt-2 mx-4">
                          <v-select class="mt-0 mr-0" label="Seleccione el idioma" dense :dark="dark" outlined
                            v-model="modelReserva.language" :items="languages" item-text="idioma" item-value="cod"
                          >
                          </v-select>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col>
                            <v-menu :dark="dark" v-model="showFechaInicio" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field :dark="dark" class="mr-2" clearable dense outlined
                                  v-model="modelReserva.fecha_inicio" label="Fecha de inicio"
                                  prepend-inner-icon="mdi-calendar" readonly v-on="on" hide-details
                                  :disabled="modelReserva.camino == null"></v-text-field>
                              </template>
                              <v-date-picker :dark="dark" color="success" locale="es"
                                v-model="modelReserva.fecha_inicio" @input="showFechaInicio = false"
                                @change="_changeFechaInicio()" first-day-of-week="1"></v-date-picker>
                            </v-menu>
                          </v-col>

                          <v-col>
                            <v-menu :dark="dark" v-model="showFechaLlegada" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field class="ml-2" :dark="dark" clearable dense outlined
                                  v-model="modelReserva.fecha_llegada" label="Fecha de llegada"
                                  prepend-inner-icon="mdi-calendar" readonly v-on="on" hide-details
                                  :disabled="modelReserva.camino == null"></v-text-field>
                              </template>
                              <v-date-picker :dark="dark" color="success" locale="es"
                                v-model="modelReserva.fecha_llegada" @input="showFechaLlegada = false"
                                first-day-of-week="1" @change="_changeFechaLlegada()"></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4 mt-6">
                          <v-textarea :rows="8" outlined v-model="modelReserva.comentarios" :dark="dark"
                            label="Comentarios"></v-textarea>
                        </v-row>

                        <v-row dense class="mx-4 mb-4">
                          <v-col align="end" cols="5">
                            <span>Cantidad de Peregrinos: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_peregrinos > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadPeregrinos('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_peregrinos }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3" @click="_setCantidadPeregrinos('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span>Individuales: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_individuales > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesIndividuales('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_individuales }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3"
                              @click="_setCantidadHabitacionesIndividuales('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span>Dobles: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_dobles > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesDobles('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_dobles }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3" @click="_setCantidadHabitacionesDobles('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <v-row dense class="mx-4">
                          <v-col align="end" cols="5">
                            <span> Triples: </span>
                          </v-col>
                          <v-col>
                            <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_triples > 0
                              ? colorAccent3
                              : 'blue-grey lighten-4'
                              " @click="_setCantidadHabitacionesTriples('-')">
                              <h3 v-bind:style="{ color: 'white' }">-</h3>
                            </v-chip>

                            <v-chip class="mx-2" label small color="black" outlined>
                              <span v-bind:style="{ color: 'black' }">
                                <h3>{{ modelReserva.cant_habitaciones_triples }}</h3>
                              </span>
                            </v-chip>
                            <v-chip label small link :color="colorAccent3"
                              @click="_setCantidadHabitacionesTriples('+')">
                              <h3 v-bind:style="{ color: 'white' }">+</h3>
                            </v-chip>
                          </v-col>
                        </v-row>

                        <!--   <v-row dense class="mx-4">
                      <v-col align="end" cols="5">
                        <span> Cuádruples: </span>
                      </v-col>
                      <v-col>
                        <v-chip class="ml-2" label small link :color="modelReserva.cant_habitaciones_cuadruples > 0
                          ? colorAccent3
                          : 'blue-grey lighten-4'
                          " @click="_setCantidadHabitacionesCuadruples('-')">
                          <h3 v-bind:style="{ color: 'white' }">-</h3>
                        </v-chip>

                        <v-chip class="mx-2" label small color="black" outlined>
                          <span v-bind:style="{ color: 'black' }">
                            <h3>{{ modelReserva.cant_habitaciones_cuadruples }}</h3>
                          </span>
                        </v-chip>
                        <v-chip label small link :color="colorAccent3" @click="_setCantidadHabitacionesCuadruples('+')">
                          <h3 v-bind:style="{ color: 'white' }">+</h3>
                        </v-chip>
                      </v-col>
                    </v-row> -->
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mt-0 mx-4 mb-2 text-center">
                          <v-spacer></v-spacer>
                          <span v-bind:style="{ color: 'grey' }">Datos del cliente
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>

                        <v-row dense class="mx-6 mb-2">
                          <v-select outlined dense hide-details :dark="dark" autocomplete="off"
                            v-model="modelReserva.cliente.tipoCliente" label="Tipo de Cliente"
                            :items="tiposCliente"></v-select>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.nombre" class="mx-4 mb-2" label="Nombre"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorNombre(modelReserva.cliente.nombre)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.apellidos" class="mx-4 mb-2" label="Apellidos"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorNombre(modelReserva.cliente.apellidos)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.telefono" class="mx-4 mb-2" label="Teléfono"
                            type="text" outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorTelefono(modelReserva.cliente.telefono)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.email" class="mx-4 mb-2" label="Email" type="text"
                            outlined dense :dark="dark" autocomplete="off" @keypress.enter="
                              _buscarPorEmail(modelReserva.cliente.email)
                              " hide-details>
                          </v-text-field>
                        </v-row>

                        <v-row dense class="mx-2">
                          <v-text-field v-model="modelReserva.cliente.documento" class="mx-4 mb-2" label="Documento"
                            type="text" outlined dense :dark="dark" autocomplete="off" hide-details>
                          </v-text-field>
                        </v-row>
                        <v-row dense class="mx-2">
                          <v-textarea v-model="modelReserva.cliente.direccion" class="mx-4 mb-2"
                            label="Dirección del cliente" type="text" outlined dense :dark="dark" autocomplete="off"
                            rows="2" hide-details>
                          </v-textarea>
                        </v-row>
                        <v-row dense class="mx-2">
                          <v-textarea v-model="modelReserva.cliente.comentarios" class="mx-4 mb-2" 
                            label="Observaciones del cliente" type="text" outlined dense :dark="dark"
                            autocomplete="false" rows="8" hide-details>
                          </v-textarea>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mt-0 mx-4 mb-2 text-center">
                          <v-spacer></v-spacer>
                          <span v-bind:style="{ color: 'grey' }">Datos de las etapas
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>

                        <v-card v-if="infoEtapas.length > 0" class="mb-1" v-for="(etapa, i) in infoEtapas"
                          :key="etapa.etapa.id" :style="'border: 2px solid black'">
                          <v-card-text>
                            <v-row class="mb-2" :dark="!dark" dense :color="'white'" flat>
                              <v-chip class="mr-1 py-3" label small :color="'grey'" :style="'border: 3px solid grey'">
                                <h3 :style="{ color: 'white' }"> {{ etapa.fecha }}
                                </h3>
                              </v-chip>
                              <v-divider class="mx-2" inset vertical></v-divider>
                              <h3>{{ etapa.etapa.final_punto.nombre }}</h3>
                              <v-spacer></v-spacer>
                            </v-row>
                          </v-card-text>
                        </v-card>

                        <v-card v-if="modelReserva.etapas.length > 0" class="mb-1"
                          v-for="(etapa, i) in modelReserva.etapas" :key="etapa.fecha"
                          :style="'border: 2px solid black'">
                          <v-card-text>
                            <v-row class="mb-2" :dark="!dark" dense :color="'white'" flat>
                              <v-chip class="mr-1 py-3" label small :color="_getColorEstadoEtapa(etapa)"
                                :style="'border: 3px solid grey'">
                                <h3 :style="{ color: 'white' }"> {{ etapa.fecha }}
                                </h3>
                              </v-chip>
                              <v-divider class="mx-2" inset vertical></v-divider>
                              <h3>{{ _getNombreFinalEtapa(etapa.etapa_id) }}</h3>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row class="mb-2" v-for="(proveedor, i) in etapa.proveedores" :key="proveedor.id"
                              :dark="!dark" dense :color="'white'" flat>
                              <v-col cols="auto">
                                <v-icon :color="_colorEstadoAlojamiento(proveedor)">mdi-home</v-icon>
                              </v-col>
                              <v-col>
                                {{ proveedor.nombre }}
                              </v-col>

                            </v-row>

                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card>
                      <v-card-text>
                        <v-row dense class="mt-0 mx-4 mb-2 text-center">
                          <v-spacer></v-spacer>
                          <span v-bind:style="{ color: 'grey' }">Datos de los pasajeros
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>



                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col cols="3">
          <v-row class="mt-12 mx-4">
            <v-text-field outlined dense :dark="dark" autocomplete="off" v-model="modelReserva.importe_presupuestado"
              label="Importe presupuestado"></v-text-field>
          </v-row>
          <v-row class="mx-4">
            <v-textarea outlined dense :dark="dark" autocomplete="off"
              v-model="modelReserva.descripcion_importe_presupuestado"
              rows="20"
              label="Descripción del importe presupuestado"></v-textarea>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EtapaFormulario from "@/components/formularios/EtapaFormulario.vue";

export default {
  name: "ReservaFormulario",
  components: {
    EtapaFormulario,
  },
  data: () => ({
    loading: false,

    modelEtapa: null,
    accionEtapa: "",
    dialogFormularioEtapa: false,
    showConfirmacionEliminacionEtapa: false,

    showFechaInicio: false,
    showFechaLlegada: false,
    dialogBusquedaClientes: false,

    infoEtapas: [],

    tab: null, // Para controlar el tab activo
    tabHeaders: ['Datos de Reserva', 'Cliente', 'Etapas', 'Pasajeros'], // Nombres de los tabs

    languages: [
      { cod: 'ES', idioma: 'Español' },
      { cod: 'EN', idioma: 'Inglés' },
      { cod: 'DE', idioma: 'Alemán' },
    ],

  }),

  props: {
    modelReserva: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "dificultades",
      "tiposCliente",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("caminos", ["caminos", "caminoSelec"]),
    ...mapState("clientes", ["clientes", "clienteSelec"]),
    ...mapState("origenes", ["origenes", "origenSelec"]),
    ...mapState("estados", ["estados"]),
  },


  mounted() {
    this._getCaminos();
    this._getOrigenes();
    if (this.accion == "editar" && this.modelReserva.etapas.length == 0) {
      this._actualizarInfoEtapas();
    }

  },

  methods: {
    ...mapActions("reservas", ["getReservas", "crearReserva", "updateReserva"]),
    ...mapActions("caminos", ["getCaminos"]),
    ...mapActions("clientes", ["getClientes"]),
    ...mapActions("origenes", ["getOrigenes"]),
    ...mapMutations("caminos", ["setCaminoSelec"]),


    _cerrarVentana() {
      this.infoEtapas = [];
      this.$emit("cerrarFormularioReserva");
    },

    async _getCaminos() {
      await this.getCaminos([this.access_token, false]);
      console.log('caminos: ', this.caminos);
    },

    async _getOrigenes() {
      await this.getOrigenes([this.access_token, false]);
      console.log('origenes: ', this.origenes);
    },

    _getNombreFinalEtapa(etapa_id) {
      let etapa = this.modelReserva.camino.etapas.find(c => c.id == etapa_id);
      if (etapa != null) {
        return etapa.final_punto.nombre;
      }
      return '';
    },


    _changeCamino() {
      this.modelReserva.fecha_inicio = null;
      this.modelReserva.fecha_llegada = null;
      console.log('Camino: ', this.modelReserva.camino);
      this._actualizarInfoEtapas();
      this._actualizarImportePresupuestado();
    },

    calcularNochesJulioAgosto() {
      let noches = 0;
      // Iterar desde la fecha de inicio hasta la fecha de llegada
      for (let i = 0; i < this.infoEtapas.length; i++) {
        const mes = new Date(this.infoEtapas[i].fecha).getMonth(); 
        if (mes === 6 || mes === 7) {
          noches++;
        }
      }

      return noches;
    },

    calcularNochesTotales() {
      console.log('infoEtapas: ', this.infoEtapas);
      return this.infoEtapas ? this.infoEtapas.length : 0;
    },

    _actualizarImportePresupuestado() {
      if (this.accion == "crear") {
        if (this.modelReserva.camino != null) {
          let nochesJulioAgosto = this.calcularNochesJulioAgosto();
          if (this.modelReserva.camino.suplemento != null && this.modelReserva.camino.suplemento > 0 && nochesJulioAgosto > 0) {

            let nochesTotales = this.calcularNochesTotales();
           
            let precioSinSuplemento = (this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind +
              this.modelReserva.cant_habitaciones_dobles * this.modelReserva.camino.precio_doble +
              this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple);
            let precioSinSuplementoPorDia = (precioSinSuplemento / nochesTotales).toFixed(2);

            let precioConSuplemento = precioSinSuplemento + (precioSinSuplemento * this.modelReserva.camino.suplemento / 100);
            let precioConSuplementoPorDia = (precioConSuplemento / nochesTotales).toFixed(2);

            let importeTotalSinSuplemento = (precioSinSuplementoPorDia * (nochesTotales - nochesJulioAgosto)).toFixed(2);
            let importeTotalConSuplemento = (precioConSuplementoPorDia * nochesJulioAgosto).toFixed(2);

            let importeTotal = (parseFloat(importeTotalSinSuplemento) + parseFloat(importeTotalConSuplemento)).toFixed(2);


            this.modelReserva.descripcion_importe_presupuestado = 'Importe desglosado por días: \n';
            this.modelReserva.descripcion_importe_presupuestado += 'Noches sin suplemento: ' + (nochesTotales - nochesJulioAgosto) + '\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Noches con suplemento: ' + nochesJulioAgosto + '\n\n';

            this.modelReserva.descripcion_importe_presupuestado += 'Precio sin suplemento: ' + precioSinSuplemento + ' €\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Precio con suplemento: ' + precioConSuplemento + ' €\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Precio sin suplemento por día: (' + precioSinSuplemento + ' € / ' + nochesTotales + ' noches) = ' + precioSinSuplementoPorDia + ' €\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Precio con suplemento por día: (' + precioConSuplemento + ' € / ' + nochesTotales + ' noches) = ' + precioConSuplementoPorDia + ' €\n\n';

            this.modelReserva.descripcion_importe_presupuestado += 'Importe total sin suplemento: (' + precioSinSuplementoPorDia + ' € x ' + (nochesTotales - nochesJulioAgosto) + ' noches) = ' + importeTotalSinSuplemento + ' €\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Importe total con suplemento: (' + precioConSuplementoPorDia + ' € x ' + nochesJulioAgosto + ' noches) = ' + importeTotalConSuplemento + ' €\n\n';
            this.modelReserva.descripcion_importe_presupuestado += 'Importe total: (' + importeTotalSinSuplemento + ' € + ' + importeTotalConSuplemento + ' €) = ' + importeTotal + ' €\n';

            this.modelReserva.importe_presupuestado = Math.round(parseFloat(importeTotal));

          } else {
            this.modelReserva.importe_presupuestado = this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind +
              this.modelReserva.cant_habitaciones_dobles * this.modelReserva.camino.precio_doble +
              this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple;

            this.modelReserva.descripcion_importe_presupuestado = 'Importe presupuestado para: \n';
            if (this.modelReserva.cant_habitaciones_individuales > 0) {
              this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.cant_habitaciones_individuales + ' Ind x ' + this.modelReserva.camino.precio_ind + ' € = ' + this.modelReserva.cant_habitaciones_individuales * this.modelReserva.camino.precio_ind + ' €\n';
            }
            if (this.modelReserva.cant_habitaciones_dobles > 0) {
              this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.cant_habitaciones_dobles + ' Doble x ' + this.modelReserva.camino.precio_doble + ' € = ' + this.modelReserva.cant_habitaciones_dobles * this.modelReserva.camino.precio_doble + ' €\n';
            }
            if (this.modelReserva.cant_habitaciones_triples > 0) {
              this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.cant_habitaciones_triples + ' Triple x ' + this.modelReserva.camino.precio_triple + ' € = ' + this.modelReserva.cant_habitaciones_triples * this.modelReserva.camino.precio_triple + ' €\n';
            }
          }
        }
      }
    },

    _changeFechaInicio() {
      if (this.modelReserva.camino != null && this.modelReserva.camino.etapas.length > 0) {
        this.modelReserva.fecha_llegada = new Date(this.modelReserva.fecha_inicio);
        this.modelReserva.fecha_llegada.setDate(this.modelReserva.fecha_llegada.getDate() + (this.modelReserva.camino.etapas.length - 1));
        this.modelReserva.fecha_llegada = this.modelReserva.fecha_llegada.toISOString().slice(0, 10);
      }
      this._actualizarInfoEtapas();
      this._actualizarImportePresupuestado();
    },

    _changeFechaLlegada() {
      if (this.modelReserva.camino != null && this.modelReserva.camino.etapas.length > 0) {
        this.modelReserva.fecha_inicio = new Date(this.modelReserva.fecha_llegada);
        this.modelReserva.fecha_inicio.setDate(this.modelReserva.fecha_inicio.getDate() - (this.modelReserva.camino.etapas.length - 1));
        this.modelReserva.fecha_inicio = this.modelReserva.fecha_inicio.toISOString().slice(0, 10);
      }
      this._actualizarInfoEtapas();
      this._actualizarImportePresupuestado();
    },

    _actualizarInfoEtapas() {
      if (this.accion == "crear" || (this.accion == "editar" && this.modelReserva.etapas.length == 0)) {
        if (this.modelReserva.camino != null && this.modelReserva.fecha_inicio != null && this.modelReserva.fecha_llegada != null) {
          this.infoEtapas = [];
          let fecha = new Date(this.modelReserva.fecha_inicio);

          let etapas = this.modelReserva.camino.etapas;
          etapas.forEach((etapa, index) => {
            let info = {
              etapa: etapa,
              fecha: new Date(fecha).toISOString().slice(0, 10),
            };
            if (etapa.inicio_punto.nombre == 'Santiago de Compostela' && etapa.final_punto.nombre == 'Santiago de Compostela') {

            } else {
              this.infoEtapas.push(info);
            }

            fecha.setDate(fecha.getDate() + 1);
          });
        }

      }
    },

    _setCantidadPeregrinos(accion) {
      if (accion == "-") {
        this.modelReserva.cant_peregrinos > 0
          ? (this.modelReserva.cant_peregrinos =
            this.modelReserva.cant_peregrinos - 1)
          : (this.modelReserva.cant_peregrinos = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_peregrinos =
          this.modelReserva.cant_peregrinos + 1;
      }
    },

    _setCantidadHabitacionesIndividuales(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_individuales > 0
          ? (this.modelReserva.cant_habitaciones_individuales =
            this.modelReserva.cant_habitaciones_individuales - 1)
          : (this.modelReserva.cant_habitaciones_individuales = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_individuales =
          this.modelReserva.cant_habitaciones_individuales + 1;
      }
    },

    _setCantidadHabitacionesIndividuales(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_individuales > 0
          ? (this.modelReserva.cant_habitaciones_individuales =
            this.modelReserva.cant_habitaciones_individuales - 1)
          : (this.modelReserva.cant_habitaciones_individuales = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_individuales =
          this.modelReserva.cant_habitaciones_individuales + 1;
      }
      this._actualizarImportePresupuestado();
    },

    _setCantidadHabitacionesDobles(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_dobles > 0
          ? (this.modelReserva.cant_habitaciones_dobles =
            this.modelReserva.cant_habitaciones_dobles - 1)
          : (this.modelReserva.cant_habitaciones_dobles = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_dobles =
          this.modelReserva.cant_habitaciones_dobles + 1;
      }
      this._actualizarImportePresupuestado();
    },

    _setCantidadHabitacionesTriples(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_triples > 0
          ? (this.modelReserva.cant_habitaciones_triples =
            this.modelReserva.cant_habitaciones_triples - 1)
          : (this.modelReserva.cant_habitaciones_triples = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_triples =
          this.modelReserva.cant_habitaciones_triples + 1;
      }
      this._actualizarImportePresupuestado();
    },

    _getColorEstadoEtapa(etapa) {
      let res = "#FFFFFF";

      const allCanceled = etapa.proveedores.every(prov => prov.estado_id === 5);
      if (allCanceled) {
        const est = this.estados.findIndex(r => r.id === 5);
        return this.estados[est].color;
      }

      const someCompleted = etapa.proveedores.some(prov => prov.estado_id === 6);
      if (someCompleted) {
        const est = this.estados.findIndex(r => r.id === 6);
        return this.estados[est].color;
      }

      const isPending = etapa.proveedores.some(prov => prov.estado_id === 4);
      if (isPending) {
        const est = this.estados.findIndex(r => r.id === 4);
        return this.estados[est].color;
      }

      return res;
    },

    _colorEstadoAlojamiento(aloj) {
      const est = this.estados.findIndex(e => e.id === aloj.estado_id);
      return this.estados[est].color;
    },

    _setCantidadHabitacionesCuadruples(accion) {
      if (accion == "-") {
        this.modelReserva.cant_habitaciones_cuadruples > 0
          ? (this.modelReserva.cant_habitaciones_cuadruples =
            this.modelReserva.cant_habitaciones_cuadruples - 1)
          : (this.modelReserva.cant_habitaciones_cuadruples = 0);
      } else if (accion == "+") {
        this.modelReserva.cant_habitaciones_cuadruples =
          this.modelReserva.cant_habitaciones_cuadruples + 1;
      }
    },


    async _guardarReserva() {
      this.loading = true;

      if (this.accion == "crear") {
        var res = await this.crearReserva([
          this.access_token,
          this.modelReserva,
        ]);
        const params = {};
        this._cerrarVentana();
        await this.getReservas([this.access_token, false]);
      } else if (this.accion == "editar") {
        var res = await this.updateReserva([
          this.access_token,
          this.modelReserva,
        ]);
        this._cerrarVentana();
      }
      this.loading = false;
    },

    _crearEtapa() {
      this._inicializarModelEtapa();
      this.accionEtapa = 'crear';
      this.dialogFormularioEtapa = true;
    },

    _inicializarModelEtapa() {
      this.modelEtapa = {
        id: null,
        titulo: null,
        descripcion: null,
        inicio_punto: null,
        final_punto: null,
        dificultad: null,
        duracion: null,
        distancia: null,
      };
    },

    _editarEtapa(item) {
      this.setEtapaSelec(item);
      let temp = JSON.parse(JSON.stringify(this.etapaSelec));
      this.modelEtapa = temp;
      this.accionEtapa = 'editar';
      this.dialogFormularioEtapa = true;
    },

    _deleteEtapa(etapa) {
    },

    _buscarPorTelefono(value) {
      const params = {};
      params.telefono = value;
      this._buscarCliente(params);
    },

    _buscarPorNombre(value) {
      const params = {};
      params.nombre = value;
      this._buscarCliente(params);
    },

    _buscarPorEmail(value) {
      const params = {};
      params.email = value;
      this._buscarCliente(params);
    },

    async _buscarCliente(params) {
      if (this.modelReserva.id == null) {
        await this.getClientes([this.access_token, params, false]);
        if (this.clientes && this.clientes.length) {
          this.dialogBusquedaClientes = true;
        } else {
        }
      }
    },

    _selecCliente(client) {
      this.modelReserva.cliente = client;
      this.dialogBusquedaClientes = false;
    },
  },
};
</script>
